import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ecf84bf&scoped=true"
import script from "./script.ts?vue&type=script&lang=ts&external"
export * from "./script.ts?vue&type=script&lang=ts&external"
import style0 from "./style.scss?vue&type=style&index=0&id=7ecf84bf&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf84bf",
  null
  
)

export default component.exports